import React, { useState, useEffect, useCallback } from "react";
import { FaTrash, FaCheck, FaPlus, FaHeading } from "react-icons/fa";
import {
  Modal,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Dialog,
  Button,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextareaAutosize,
} from "@mui/material";
import "./ViewHseReportDetails.css";
import CloseIcon from "@material-ui/icons/Close";
import IconButton from "@material-ui/core/IconButton";
import { config } from "../../config";
import axios from "../../APIs/axios";
import Chart from "react-apexcharts";
import ImageViewerModal from "../ImageViewerModal/ImageViewerModal";
import InsertPhotoOutlinedIcon from "@mui/icons-material/InsertPhotoOutlined";
import { groupReferences } from "../../utils/annexureGrouping";

// Normalize a missing field value to a fallback ("N/A" for text fields, 0 for
// numeric fields like score / max_pts). Covers real null / undefined / empty
// strings AND the literal strings "null" / "undefined", which some observation
// records store as text (e.g. equipment, status).
const naValue = (value, fallback = "N/A") => {
  if (value === null || value === undefined) return fallback;
  const s = String(value).trim();
  if (s === "" || s.toLowerCase() === "null" || s.toLowerCase() === "undefined") {
    return fallback;
  }
  return value;
};

const ViewHseReportSectionBasedDetails = ({
  selectedReportData,
  setOpenViewReport,
  reportHeader,
  screenNumber,
  completeReport
}) => {
  const [criticalObservation, setCriticalObservations] = useState([]);
  const [selectedObservation, setSelectedObservation] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [data, setData] = useState([]);
  const [scorePercent, setScorePercent] = useState(0);
  const [selectedImage, setSelectedImage] = useState(null);
  const [facilityInfo, setFacilityInfo] = useState({
    "Name of Facility": "",
    "Address & Location": "",
    "Geographical Co-ordinates Seismic Zone": "",
    "Brief Property Description:": "",
    "Type of Construction": "",
    "Number of Floors": "",
    "Average Worker Foot Fall:": "",
    "No Objection Certificate": "",
  });
  const [selectedOrganization, setSelectedOrganization] = useState({
    label: selectedReportData.organization,
    value: selectedReportData.org_id,
  });
  // console.log("brief",selectedReportData)
  const [selectedSite, setSelectedSite] = useState({
    label: selectedReportData.site,
    value: selectedReportData.site,
  });
  const [selectedState, setSelectedState] = useState({
    label: selectedReportData.state,
    value: selectedReportData.state,
  });
  const [startDate, setStartDate] = useState(selectedReportData.start_date);
  const [endDate, setEndDate] = useState(selectedReportData.end_date);
  const [timeFrom, setTimeFrom] = useState(selectedReportData.time_of_audit_from);
  const [timeTo, setTimeTo] = useState(selectedReportData.time_of_audit_to);
  const [briefPropertyDescription, setBriefPropertyDescription] = useState(selectedReportData.brief_property_description);
  const [numOfFloors, setNumOfFloors] = useState(selectedReportData.num_of_floors);
  const [avgStaffFootfall, setAvgStaffFootfall] = useState(selectedReportData.average_staff_footfall);
  const [noObjectionCertificate, setNoObjectionCertificate] = useState(selectedReportData.no_objection_certificate);
  const [nationalBuildingCodeCategory, setNationalBuildingCodeCategory] = useState(selectedReportData.national_building_code_category);
  const [coordinationgPersonClientside, setCoordinationgPersonClientside] = useState(selectedReportData.coordinating_person_clientSide);
  const [reportPreparedBy, setReportPreparedBy] = useState(selectedReportData.report_prepared_by);
  const [reportReviewedBy, setReportReviewedBy] = useState(selectedReportData.report_reviewed_by);
  const [buildingName, setBuildingName] = useState(selectedReportData.building_name)
  const [keyObservationDisplay,setKeyObservationDisplay] = useState(null);
  const formattedDateTime = `${selectedReportData.date_time.split("T")[0].split("-")[2]
    }-${selectedReportData.date_time.split("T")[0].split("-")[1]}-${selectedReportData.date_time.split("T")[0].split("-")[0]
    } ${selectedReportData.date_time.split("T")[1]}`;

  const formattedStartDate = `${String(new Date(
    selectedReportData.start_date
  ).getDate()).padStart(2, '0')}-${String(new Date(selectedReportData.start_date).getMonth() + 1).padStart(2, '0')
    }-${new Date(selectedReportData.start_date).getFullYear()}`;

  const formattedEndDate = `${String(new Date(
    selectedReportData.end_date
  ).getDate()).padStart(2, '0')}-${String(new Date(selectedReportData.end_date).getMonth() + 1).padStart(2, '0')
    }-${new Date(selectedReportData.end_date).getFullYear()}`;
  // console.log("darta",selectedReportData)
  // useEffect(() => {
  //   getCriticalObservations();
  //   fetchDataForCharts();
  //   getFacilityInfo();
  // }, []);

  function convertBrToNestedList(html) {
  return html.replace(/<li>([\s\S]*?)<\/li>/gi, (_, content) => {
    const parts = content
      .split(/<br\s*\/?>/i)
      .map(x => x.trim())
      .filter(Boolean);

    // Only one line -> leave unchanged
    if (parts.length <= 1) {
      return `<li>${content}</li>`;
    }

    // Every line starts with 1. / 2. / 3.
    const isOrdered = parts.every(p => /^\d+\./.test(p));

    if (isOrdered) {
      const items = parts
        .map(p => `<li>${p.replace(/^\d+\.\s*/, "")}</li>`)
        .join("");

      return `<li><ol>${items}</ol></li>`;
    }

    // Otherwise create nested bullets
    const first = parts.shift();

    const nested = parts
      .map(p => `<li>${p}</li>`)
      .join("");

    return `
      <li>
        ${first}
        <ul>
          ${nested}
        </ul>
      </li>
    `;
  });
}
  useEffect(() => {
    if (selectedReportData) {
      if (selectedReportData.AllObservations) {
        fetchDataForCharts();

        // for empty observation check
        let HighCriticalityObservations = selectedReportData?.AllObservations?.filter((e) => e.criticality === "High").map((obs, i) =>
          `<li>
              ${obs.observation}
          </li>`
        )
          let keyCriticalObservation = "<p>High Severity Observations</p><ol>"+HighCriticalityObservations?.join('')+"</ol>"
          setKeyObservationDisplay(keyCriticalObservation);

      }
      getCriticalObservations();
      getFacilityInfo();

    }
  }, [selectedReportData]);


  const getFacilityInfo = async () => {
    const response = await axios.get(
      `${config.PATH}/api/get-facility-info/${selectedReportData.report_id}`
    );
    const data = response.data;
    // Update each field individually
    setFacilityInfo(data);
  };

  const fetchDataForCharts = () => {
    const observations =
      // selectedReportData.AllObservations.filter((e) => e.is_selected === 1) ||
      // [];
      (selectedReportData?.AllObservations || []).filter((e) => e.is_selected === 1) || [];
    //  console.log("datatatata",selectedReportData.AllObservations.score)
    const totalScore = observations.reduce((acc, item) => {
      return acc + parseFloat(item.score || 0);
    }, 0);
    const totalMaxPoints = observations.reduce((acc, item) => {
      return acc + parseFloat(item.max_pts || 0);
    }, 0);

    const percentage =
      totalMaxPoints > 0
        ? Math.floor((totalScore / totalMaxPoints) * 100)
        : 0;

    setScorePercent(isNaN(percentage) ? 0 : percentage);
    setData(observations);
    console.log("charts observation", observations);
    console.log("data length", observations.length);
  };

  const handleClose = () => {
    setOpenViewReport(false);
  };

  const getCriticalObservations = async () => {
    try {
      const res = await axios.get(
        `${config.PATH}/api/get-hse-critical-observations/${selectedReportData.report_id}`
      );
      setCriticalObservations(res.data.data);
    } catch (error) {
      console.log(error.message);
    }
  };

  const getScoreColor = (percentage) => {
    if (percentage <= 33) {
      return "#FF0000"; // Red
    } else if (percentage > 33 && percentage <= 66) {
      return "#FFA500"; // Orange
    } else {
      return "#006400"; // Dark Green
    }
  };

  // const pieOptions = {
  //   labels: [
  //     `Obtained Score(${scorePercent}%)`,
  //     `Remaining Score(${100 - scorePercent}%)`,
  //   ],
  //   colors: [getScoreColor(scorePercent), "grey"],
  //   dataLabels: {
  //     enabled: true,
  //   },
  //   legend: {
  //     show: true,
  //     position: "bottom",
  //     horizontalAlign: "center",
  //     fontSize: "14px",
  //     markers: {
  //       width: 16,
  //       height: 16,
  //     },
  //   },
  //   responsive: [
  //     {
  //       breakpoint: 480,
  //       options: {
  //         chart: {
  //           width: 200,
  //         },
  //         legend: {
  //           position: "bottom",
  //         },
  //       },
  //     },
  //   ],
  // };
  const pieOptions = {
    chart: {
      type: "pie",
      animations: {
        enabled: false, // IMPORTANT FIX
      },
    },
    labels: ["Score", "Remaining"],
    tooltip: {
      enabled: true,
    },
    legend: {
      position: "bottom",
    },
    // Hide data labels on tiny slices (< 12 deg) so percentages don't
    // overlap when the score is very low or very high (ODT-5).
    plotOptions: {
      pie: {
        dataLabels: {
          // Pull the percentage labels in toward the center so they sit
          // inside their slice instead of crossing the circle's outline
          // (a small slice like "Remaining" otherwise lands right on the rim).
          offset: -20,
          minAngleToShowLabel: 12,
        },
      },
    },
    dataLabels: {
      enabled: true,
      // Hide the in-slice label for very thin slices (<= 5%); a small
      // "Remaining" sliver's value is shown outside the circle instead
      // (see the pie render below). Larger slices keep their % label.
      formatter: (val) => (val <= 5 ? "" : `${Number(val).toFixed(0)}%`),
    },
    noData: {
      text: "No Data",
    },
  };

  function convertToHtml(text) {
  if (!text) return "";

  // Normalize line endings
  text = text.replace(/\r\n/g, "\n");

  // Split consecutive numbered items
  // Example: quarterly.2. -> quarterly.\n2.
  text = text.replace(/\.(?=\d+\.\s*)/g, ".\n");

  // Put bullets on a new line
  text = text.replace(/\s+(?=[•*-]\s*)/g, "\n");

  // Separate merged sentences like "msgA"
  text = text.replace(/([a-z])([A-Z])/g, "$1\n$2");

  const lines = text
    .split(/\n+/)
    .map(l => l.trim())
    .filter(Boolean);

  let html = "";
  let listType = null;

  const closeList = () => {
    if (listType) {
      html += `</${listType}>`;
      listType = null;
    }
  };

  for (let line of lines) {
    const ordered = line.match(/^(\d+)\.\s*(.*)$/);
    const unordered = line.match(/^[•*-]\s*(.*)$/);

    if (ordered) {
      if (listType !== "ol") {
        closeList();
        html += "<ol>";
        listType = "ol";
      }

      html += `<li>${ordered[2]}</li>`;
      continue;
    }

    if (unordered) {
      if (listType !== "ul") {
        closeList();
        html += "<ul>";
        listType = "ul";
      }

      html += `<li>${unordered[1]}</li>`;
      continue;
    }

    closeList();
    html += `<p>${line}</p>`;
  }

  closeList();

  return html;
}

  const areaCounts = data.filter((e) => !(e.criticality === "" || e.criticality === "N/A")).reduce((counts, entry) => {
    const area = entry.area;
    counts[area] = (counts[area] || 0) + 1;
    return counts;
  }, {});

  const areasForAreaChart = Object.keys(areaCounts);
  const counts = areasForAreaChart.map((area) => {
    // Skip "NA" (not applicable) rows: their status yields max_pts = 0, so they
    // shouldn't count toward the area's earned score or its possible total.
    const areaObservations = data.filter(
      (entry) => entry.area === area && parseFloat(entry.max_pts || 0) > 0
    );
    const areaScore = areaObservations.reduce(
      (acc, entry) => acc + parseFloat(entry.score || 0),
      0
    );
    // Use each observation's own max_pts (matches the overall score calc in
    // fetchDataForCharts) instead of assuming a fixed 5 points per observation,
    // so the per-area bars reconcile with the overall Audit Score.
    const totalPossibleScore = areaObservations.reduce(
      (acc, entry) => acc + parseFloat(entry.max_pts || 0),
      0
    );
    const percentage =
      totalPossibleScore > 0
        ? Math.floor((areaScore / totalPossibleScore) * 100)
        : 0;
    return percentage.toFixed(0);
  });

  const barOptions = {
    chart: {
      id: "bar-chart",
    },
    colors: ["#005cdb"],
    xaxis: {
      categories: areasForAreaChart.map((area) => {
        // Truncate the area name if it's too long
        const maxChars = 15; // Adjust the maximum characters as needed
        return area.length > maxChars
          ? area.substring(0, maxChars) + "..."
          : area;
      }),
      labels: {
        style: {
          fontSize: "10px", // Adjust the font size as needed
        },
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "30%",
        dataLabels: {
          position: "top", // top, center, bottom
        },
      },
    },
    dataLabels: {
      enabled: true,
      formatter: function (val) {
        return val;
      },
      offsetY: -20,
      style: {
        fontSize: "10px",
        colors: ["#304758"],
      },
    },
    tooltip: {
      y: {
        formatter: function (value, { dataPointIndex }) {
          // Display the full area name on hover
          const area = areasForAreaChart[dataPointIndex];
          return `${area}: ${value}%`; // Show area name along with percentage
        },
      },
    },
  };
  // Group the data by area and severity
  const areaSeverityData = data.filter((e) => !(e.criticality === "" || e.criticality === "N/A")).reduce((result, entry) => {
    const area = entry.area;
    const severity = entry.criticality;

    if (!result[area]) {
      result[area] = { High: 0, Medium: 0, Low: 0 };
    }

    result[area][severity] += 1;
    return result;
  }, {});

  // Extract areas and severity counts
  const areas = Object.keys(areaSeverityData);
  const severityChartData = Object.keys(areaSeverityData).map((area) => ({
    name: area,
    High: areaSeverityData[area].High,
    Medium: areaSeverityData[area].Medium,
    Low: areaSeverityData[area].Low,
  }));

  // Transpose the data to match the series structure
  const transposedData = {
    High: [],
    Medium: [],
    Low: [],
  };

  severityChartData.forEach((area) => {
    transposedData.High.push(area.High);
    transposedData.Medium.push(area.Medium);
    transposedData.Low.push(area.Low);
  });

  // Prepare series data with specific colors for each severity level
  const seriesData = [
    { name: "High", data: [] },
    { name: "Medium", data: [] },
    { name: "Low", data: [] },
  ];

  areas.forEach((area) => {
    seriesData[0].data.push(areaSeverityData[area]?.High || 0);
    seriesData[1].data.push(areaSeverityData[area]?.Medium || 0);
    seriesData[2].data.push(areaSeverityData[area]?.Low || 0);
  });

  // Severity chart options
  const severityChartOptions = {
    chart: {
      id: "severity-chart",
      stacked: true,
    },
    xaxis: {
      categories: areas.map((area) => {
        // Truncate the area name if it's too long
        const maxChars = 15; // Adjust the maximum characters as needed
        return area.length > maxChars
          ? area.substring(0, maxChars) + "..."
          : area;
      }),
      labels: {
        style: {
          fontSize: "10px", // Adjust the font size as needed
        },
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "30%",
        dataLabels: {
          total: {
            enabled: true,
            style: {
              fontSize: "10px", // Adjust the font size for the total data label
            },
          },
        },
      },
    },
    dataLabels: {
      enabled: false, // Hide data labels
    },
    colors: ["#FF0000", "#006400", "#005cdb"],
    tooltip: {
      y: {
        formatter: function (value, { dataPointIndex }) {
          // Display the full area name on hover
          const area = areas[dataPointIndex];
          return `${area}:${value}`;
        },
      },
    },
  };

  const groupedObservations = (selectedReportData?.AllObservations || [])
    .filter(e => e.is_selected === 1)
    .reduce((acc, observation) => {
      if (!acc[observation.table_type]) {
        acc[observation.table_type] = [];
      }
      acc[observation.table_type].push(observation);
      return acc;
    }, {});
  // console.log("griupedobs",groupedObservations)
  // Open Dialog Handler
  const handleOpenDialog = useCallback((observation) => {
    setSelectedObservation(observation);
    setOpenDialog(true);
  }, []);

  // Close Dialog Handler
  const handleCloseDialog = useCallback(() => {
    setSelectedObservation(null);
    setOpenDialog(false);
  }, []);
  const riskLevels = [
    {
      range: "≥ 85%",
      risk: "Low Risk",
      color: "#00A651",
      interpretation: "Electrical systems and controls are well maintained, only minor improvements needed.",
    },
    {
      range: "65% – 84%",
      risk: "Medium Risk",
      color: "#FFFF00",
      interpretation: "Controls are adequate but with noticeable weaknesses.",
    },
    {
      range: "25% – 64%",
      risk: "High Risk",
      color: "#FFA500",
      interpretation: "High vulnerabilities with major compliance gaps.",
    },
    {
      range: "< 25%",
      risk: "Severe Risk",
      color: "#FF0000",
      interpretation: "Controls are ineffective, urgent corrective action required.",
    },
  ];
  const getRiskLevel = (score) => {
    if (score >= 85) return riskLevels[0];
    if (score >= 65) return riskLevels[1];
    if (score >= 25) return riskLevels[2];
    return riskLevels[3];
  };

  // const currentRisk = getRiskLevel((selectedReportData.cumulative / 10) * 100);
  const currentRisk = getRiskLevel(scorePercent);

  const [references, setReferences] = useState([]);
  // Annexures hidden for THIS report (report-specific delete) are filtered out.
  const visibleReferences = references.filter(
    (ref) =>
      !(
        Array.isArray(selectedReportData?.deleted_annexure_ids)
          ? selectedReportData.deleted_annexure_ids
          : []
      ).includes(ref.id)
  );

  // Group references under their section headings for display (read-only here).
  // Shared pure helper, same one Saved/Preview use — see utils/annexureGrouping.
  const groupedReferences = groupReferences(visibleReferences);
  useEffect(() => {
    fetchReferences();
  }, []);

  const fetchReferences = async () => {
    try {
      // const res = await axios.get("http://localhost:5000/api/references");
      const res = await axios.get(
        `${config.PATH}/api/get-all-annexure-details`
      );;

      setReferences(res.data);
    } catch (err) {
      console.error("Error fetching references:", err);
    }
  };


  return (
    <div >
      <ImageViewerModal
        imageUrl={selectedImage}
        onClose={() => setSelectedImage(null)}
      />
      <Modal open={true} onClose={handleClose}>
        <div className="modal-container">
          <div className="modal-header">
            <Typography variant="h5">Report Details</Typography>
            <IconButton
              size="small"
              onClick={handleClose}
              className="close-icon"
              style={{ backgroundColor: "#efc71d" }}
            >
              <CloseIcon style={{ color: "#307248" }} />
            </IconButton>
          </div>

          <div className="modal-content">
            <div className="modal-body">
              <Typography variant="body1" component="div">
                {" "}

                {/* <div className="sub-headings">BASIC DETAILS</div>
                  <div className="basic-details" >
                    Report ID: {selectedReportData.report_id}
                    <br />
                    Date & Time: {formattedDateTime}
                    <br />
                    Organization: {selectedReportData.organization}
                    <br />
                    Site: {selectedReportData.site}
                    <br />
                    Start Date & End Date: {formattedStartDate} & {formattedEndDate}
                  </div>
                <br /> */}
                
                {/* UNDERSTANDING THE REPORT */}
                {(screenNumber == 2 || completeReport) && (
                  <>
                    <div className="sub-headings">
                      UNDERSTANDING THE REPORT
                    </div>

                    <div
                      style={{
                        // width: "100%",
                        minHeight: "100px", // Ensures a reasonable starting height
                        maxHeight: "200px", // Limits excessive expansion
                        overflowY: "auto", // Enables scrolling when content exceeds the height
                        padding: "8px", // Adds spacing inside the div
                        border: "1px solid #ccc", // Light border for better visibility
                        borderRadius: "5px", // Soft rounded corners
                        fontFamily: "inherit", // Ensures consistency with the rest of the UI
                        fontSize: "15px", // Maintains readability
                        background: "whitesmoke", // Subtle background for better readability
                        // whiteSpace: "pre-wrap", // Ensures line breaks are maintained
                        lineHeight: "1.6",
                        wordWrap: "break-word",
                        whiteSpace: "normal",
                      }}
                      dangerouslySetInnerHTML={{
                        __html:
                          (selectedReportData.contents ||
                            reportHeader.contents ||
                            "Enter your text here")
                            .replace(/<br\s*\/?>/gi, "") // remove all <br> tags
                            .replace(/<p>\s*<\/p>/gi, "") // remove empty <p> tags (optional)
                      }}
                    >
                      {/* {selectedReportData.contents || reportHeader.contents || "Enter your text here"} */}
                    </div>
                    <br />  
                  </>
                )}
                
                {/* AUDIT DESCRIPTION */}
                {(screenNumber == 3 || completeReport)  && (
                  <>
                  <div>
                    <Typography variant="body1" component="div">
                      <div className="sub-headings">
                        AUDIT DESCRIPTION
                      </div>
                      <div className="review-table-wrapper" style={{ borderRadius: "5px" }}>
                        <table style={{ width: "100%", fontFamily: "montserrat", borderCollapse: "collapse", borderRadius: "5px" }}>
                          <tbody>
                            <tr>
                              <td style={{ backgroundColor: "#FFF8DC" }}>Client</td>
                              <td>{selectedOrganization.label}</td>
                            </tr>
                            <tr>
                              <td style={{ backgroundColor: "#FFF8DC" }}>Location</td>
                              <td>{selectedSite.label}{selectedState && selectedState?.label != null  ? ", "+selectedState.label:""}</td>
                            </tr>
                            <tr>
                              <td style={{ backgroundColor: "#FFF8DC" }}>Date of Site Visit</td>
                              <td>{String(new Date(startDate).getDate()).padStart(2, '0')}-{String(new Date(startDate).getMonth() + 1).padStart(2, '0')
                              }-{new Date(startDate).getFullYear()}</td>
                            </tr>
                            <tr>
                              <td style={{ backgroundColor: "#FFF8DC" }}>Study</td>
                              <td>HSE Audit Report</td>
                            </tr>
                            <tr>
                              <td style={{ backgroundColor: "#FFF8DC" }}>Report Type</td>
                              <td>{selectedReportData.sector_type || ""}</td>
                            </tr>
                            {(timeFrom || timeTo) ?
                              <tr>
                                <td style={{ backgroundColor: "#FFF8DC" }}>Time of Audit (From & To)</td>
                                {/* <td>{timeFrom.slice(0, 5)} to {timeTo.slice(0, 5)}</td> */}
                                <td>
                                  {
                                    (timeFrom && timeTo
                                      ? `${timeFrom.slice(0, 5)} to ${timeTo.slice(0, 5)}`
                                      : timeFrom
                                        ? `${timeFrom.slice(0, 5)} to N/A`
                                        : timeTo
                                          ? `N/A to ${timeTo.slice(0, 5)}`
                                          : "N/A") + (" (Date wise breakup)")}
                                </td>

                              </tr>
                              : []}
                            {briefPropertyDescription ?
                              <tr>
                                <td style={{ backgroundColor: "#FFF8DC" }}>Brief Property Description</td>
                                <td>{briefPropertyDescription}</td>
                              </tr>
                              : []}
                            {numOfFloors ?
                              <tr>
                                <td style={{ backgroundColor: "#FFF8DC" }}>Number of floors</td>
                                <td>{numOfFloors}</td>
                              </tr>
                              : []}
                            {avgStaffFootfall ?
                              <tr>
                                <td style={{ backgroundColor: "#FFF8DC" }}>Average Staff Footfall</td>
                                <td>{avgStaffFootfall}</td>
                              </tr>
                              : []}
                            {noObjectionCertificate ?
                              <tr>
                                <td style={{ backgroundColor: "#FFF8DC" }}>No Objection Certificate:</td>
                                <td>{noObjectionCertificate}</td>
                              </tr>
                              : []}
                            {nationalBuildingCodeCategory ?
                              <tr>
                                <td style={{ backgroundColor: "#FFF8DC" }}>National Building Code Category</td>
                                <td>{nationalBuildingCodeCategory}</td>
                              </tr>
                              : []}
                            {coordinationgPersonClientside ?
                              <tr>
                                <td style={{ backgroundColor: "#FFF8DC" }}>Coordinating Person – Client Side</td>
                                <td>{coordinationgPersonClientside}</td>
                              </tr>
                              : []}
                            {reportPreparedBy ?
                              <tr>
                                <td style={{ backgroundColor: "#FFF8DC" }}>Report Prepared By</td>
                                <td>{reportPreparedBy}</td>
                              </tr>
                              : []}
                            {reportReviewedBy ?
                              <tr>
                                <td style={{ backgroundColor: "#FFF8DC" }}>Report Reviewed By</td>
                                <td>{reportReviewedBy}</td>
                              </tr>
                              : []}
                            {buildingName ?
                              <tr>
                                <td style={{ backgroundColor: "#FFF8DC" }}>Building Name</td>
                                <td>{buildingName}</td>
                              </tr>
                              : []}
                            <tr>
                              <td style={{ backgroundColor: "#FFF8DC" }}>Date of Submission of Report</td>
                              <td>{String(new Date(endDate).getDate()).padStart(2, '0')}-{String(new Date(endDate).getMonth() + 1).padStart(2, '0')
                              }-{new Date(endDate).getFullYear()}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </Typography>
                  </div>
                  <br />
                  </>
                )}
                
                {/* CLASSIFICATION OF AUDIT OBSERVATIONS */}
                {(screenNumber == 4 || completeReport) && (
                  <>
                  <div className="sub-headings">CLASSIFICATION OF AUDIT OBSERVATIONS</div>
                  <div
                    style={{
                      // width: "100%",
                      minHeight: "100px", // Ensures a reasonable starting height
                      maxHeight: "200px", // Limits excessive expansion
                      overflowY: "auto", // Enables scrolling when content exceeds the height
                      padding: "8px", // Adds spacing inside the div
                      border: "1px solid #ccc", // Light border for better visibility
                      borderRadius: "5px", // Soft rounded corners
                      fontFamily: "inherit", // Ensures consistency with the rest of the UI
                      fontSize: "15px", // Maintains readability
                      background: "whitesmoke", // Subtle background for better readability
                      // whiteSpace: "pre-wrap", // Keeps line breaks intact
                      lineHeight: "1.6",
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                    }}
                    dangerouslySetInnerHTML={{
                      __html:
                        // selectedReportData.background_brief ||
                        // reportHeader.background_brief ||
                        // "Enter your text here",

                        (selectedReportData.classification_of_audit_observations ||
                          reportHeader.classification_of_audit_observations ||
                          "Enter your text here"
                        )
                          .replace(/<br\s*\/?>/gi, "") // remove all <br> tags
                          .replace(/<p>\s*<\/p>/gi, "") // remove empty <p> tags (optional)

                    }}
                  >
                    {/* {selectedReportData.background_brief || reportHeader.background_brief || "Enter your text here"} */}
                    {/* {(selectedReportData.background_brief || reportHeader.background_brief || "Enter your text here")
      .replace(/<\/?[^>]+(>|$)/g, "")}  */}

                  </div>
                  <br />
                  </>
                )}

                {/* AUDIT OBJECTIVE */}
                {(screenNumber == 5 || completeReport) && (
                  <>
                  <div className="sub-headings">AUDIT OBJECTIVE</div>
                  <div
                    style={{
                      // width: "100%",
                      minHeight: "100px", // Ensures a reasonable starting height
                      maxHeight: "200px", // Limits excessive expansion
                      overflowY: "auto", // Enables scrolling when content exceeds the height
                      padding: "8px", // Adds spacing inside the div
                      border: "1px solid #ccc", // Light border for better visibility
                      borderRadius: "5px", // Soft rounded corners
                      fontFamily: "inherit", // Ensures consistency with the rest of the UI
                      fontSize: "15px", // Maintains readability
                      background: "whitesmoke", // Subtle background for better readability
                      // whiteSpace: "pre-wrap", // Keeps line breaks intact
                      lineHeight: "1.6",
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                    }}
                    dangerouslySetInnerHTML={{
                      __html:
                        // selectedReportData.background_brief ||
                        // reportHeader.background_brief ||
                        // "Enter your text here",

                        (selectedReportData.background_brief ||
                          reportHeader.background_brief ||
                          "Enter your text here"
                        )
                          .replace(/<br\s*\/?>/gi, "") // remove all <br> tags
                          .replace(/<p>\s*<\/p>/gi, "") // remove empty <p> tags (optional)

                    }}
                  >
                    {/* {selectedReportData.background_brief || reportHeader.background_brief || "Enter your text here"} */}
                    {/* {(selectedReportData.background_brief || reportHeader.background_brief || "Enter your text here")
      .replace(/<\/?[^>]+(>|$)/g, "")}  */}

                  </div>
                  <br />
                  </>
                )}

                {/* EXECUTIVE SUMMARY */}
                {(screenNumber == 6 || completeReport) && (
                  <>
                  <div className="sub-headings">EXECUTIVE SUMMARY</div>
                  <div
                    style={{
                      // width: "100%",
                      minHeight: "100px", // Ensures a reasonable starting height
                      maxHeight: "400px", // Allows expansion before scrolling
                      overflowY: "auto", // Enables scrolling when content exceeds max height
                      padding: "8px", // Adds spacing inside the div
                      border: "1px solid #ccc", // Light border for better visibility
                      borderRadius: "5px", // Soft rounded corners
                      fontFamily: "inherit", // Ensures consistency with the rest of the UI
                      fontSize: "15px", // Maintains readability
                      background: "whitesmoke", // Subtle background for better readability
                      // whiteSpace: "pre-wrap", // Ensures line breaks are maintained
                      lineHeight: "1.6",
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                    }}
                    dangerouslySetInnerHTML={{
                      __html:
                        // selectedReportData.exe_summary ||
                        // reportHeader.exe_summary ||
                        // "Enter your text here",
                        (selectedReportData.exe_summary ||
                          reportHeader.exe_summary ||
                          "Enter your text here"
                        )
                          .replace(/<br\s*\/?>/gi, "")
                          .replace(/<p>\s*<\/p>/gi, ""),
                    }}
                  >
                    {/* {selectedReportData.exe_summary || reportHeader.exe_summary || "Enter your text here"} */}
                  </div>
                  <br />
                  <div className="sub-headings">Findings</div>
                  <div
                    style={{
                      // width: "100%",
                      minHeight: "100px", // Ensures a reasonable starting height
                      maxHeight: "400px", // Allows expansion before scrolling
                      overflowY: "auto", // Enables scrolling when content exceeds max height
                      padding: "8px", // Adds spacing inside the div
                      border: "1px solid #ccc", // Light border for better visibility
                      borderRadius: "5px", // Soft rounded corners
                      fontFamily: "inherit", // Ensures consistency with the rest of the UI
                      fontSize: "15px", // Maintains readability
                      background: "whitesmoke", // Subtle background for better readability
                      // whiteSpace: "pre-wrap", // Ensures line breaks are maintained
                      lineHeight: "1.6",
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                    }}
                    dangerouslySetInnerHTML={{
                      __html:
                        // selectedReportData.exe_summary ||
                        // reportHeader.exe_summary ||
                        // "Enter your text here",
                        (selectedReportData.findings ||
                          "<p>Findings were categorised under System, Infrastructure, Capability, and Legal to prioritise corrective actions based on criticality.</p><p>Overall, the facility demonstrates a developing HSE framework with certain compliant practices in place; however, multiple high and extreme risk gaps require immediate management intervention to ensure legal compliance, hazard control, and operational resilience.</p><ul><li>Legal: </li><li>System:</li> <li>Infrastructure:</li><li>Capability:</li></ul>" ||
                          "Enter your text here"
                        )
                          .replace(/<br\s*\/?>/gi, "")
                          .replace(/<p>\s*<\/p>/gi, ""),
                    }}
                  >
                    {/* {selectedReportData.exe_summary || reportHeader.exe_summary || "Enter your text here"} */}
                  </div>
                  <br/>
                  <div className="sub-headings">Key Observations</div>
                  {/* <div
                      style={{
                        flexGrow: 1,
                        minHeight: "100px",
                        maxHeight: "400px",
                        overflowY: "auto",
                        padding: "8px",
                        border: "1px solid #ccc",
                        borderRadius: "5px",
                        fontFamily: "inherit",
                        fontSize: "15px",
                        background: "whitesmoke",
                        lineHeight: "1.6",
                        wordWrap: "break-word",
                        whiteSpace: "normal",
                      }}
                      dangerouslySetInnerHTML={{
                        __html:
                          (keyObservationDisplay ||
                            "<p>No Observation Selected</p>")
                            .replace(/<br\s*\/?>/gi, "")
                            .replace(/<p>\s*<\/p>/gi, ""),
                      }}
                    >
                  </div> */}
                  <div
                    style={{
                      // width: "100%",
                      minHeight: "100px", // Ensures a reasonable starting height
                      maxHeight: "400px", // Allows expansion before scrolling
                      overflowY: "auto", // Enables scrolling when content exceeds max height
                      padding: "8px", // Adds spacing inside the div
                      border: "1px solid #ccc", // Light border for better visibility
                      borderRadius: "5px", // Soft rounded corners
                      fontFamily: "inherit", // Ensures consistency with the rest of the UI
                      fontSize: "15px", // Maintains readability
                      background: "whitesmoke", // Subtle background for better readability
                      // whiteSpace: "pre-wrap", // Ensures line breaks are maintained
                      lineHeight: "1.6",
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                    }}
                    dangerouslySetInnerHTML={{
                      __html:
                        // selectedReportData.exe_summary ||
                        // reportHeader.exe_summary ||
                        convertBrToNestedList(selectedReportData.key_observations ||
                          "<p>No observation added</p>" ||
                          "Enter your text here"
                        )
                          .replace(/<br\s*\/?>/gi, "")
                          .replace(/<p>\s*<\/p>/gi, ""),
                    }}
                  >
                    {/* {selectedReportData.exe_summary || reportHeader.exe_summary || "Enter your text here"} */}
                  </div>  
                  <br/>
                  </>
                )}
                
                {/* AUDIT SCORE ANALYSIS */}
                {(screenNumber == 7 || completeReport) && (
                  <>
                  <div className="sub-headings">AUDIT SCORE ANALYSIS</div>
                  <div
                    style={{
                      // width: "100%",
                      minHeight: "100px", // Ensures a reasonable starting height
                      maxHeight: "200px", // Limits excessive expansion
                      overflowY: "auto", // Enables scrolling when content exceeds the height
                      padding: "8px", // Adds spacing inside the div
                      border: "1px solid #ccc", // Light border for better visibility
                      borderRadius: "5px", // Soft rounded corners
                      fontFamily: "inherit", // Ensures consistency with the rest of the UI
                      fontSize: "15px", // Maintains readability
                      background: "whitesmoke", // Subtle background for better readability
                      // whiteSpace: "pre-wrap", // Keeps line breaks intact
                      lineHeight: "1.6",
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                    }}
                    dangerouslySetInnerHTML={{
                      __html:
                        // selectedReportData.background_brief ||
                        // reportHeader.background_brief ||
                        // "Enter your text here",

                        (selectedReportData.audit_score_analysis ||
                          reportHeader.audit_score_analysis ||
                          "Enter your text here"
                        )
                          .replace(/<br\s*\/?>/gi, "") // remove all <br> tags
                          .replace(/<p>\s*<\/p>/gi, "") // remove empty <p> tags (optional)

                    }}
                  >
                    {/* {selectedReportData.background_brief || reportHeader.background_brief || "Enter your text here"} */}
                    {/* {(selectedReportData.background_brief || reportHeader.background_brief || "Enter your text here")
      .replace(/<\/?[^>]+(>|$)/g, "")}  */}

                  </div>
                  <br />
                  </>
                )}
                
                {/* IMPROVEMENT OPPORTUNITY AREAS */}
                {(screenNumber == 8 || completeReport) && (
                  <>
                  <div className="sub-headings">IMPROVEMENT OPPORTUNITY AREAS</div>
                  <div
                    style={{
                      // width: "100%",
                      minHeight: "100px", // Ensures a reasonable starting height
                      maxHeight: "200px", // Limits excessive expansion
                      overflowY: "auto", // Enables scrolling when content exceeds the height
                      padding: "8px", // Adds spacing inside the div
                      border: "1px solid #ccc", // Light border for better visibility
                      borderRadius: "5px", // Soft rounded corners
                      fontFamily: "inherit", // Ensures consistency with the rest of the UI
                      fontSize: "15px", // Maintains readability
                      background: "whitesmoke", // Subtle background for better readability
                      // whiteSpace: "pre-wrap", // Keeps line breaks intact
                      lineHeight: "1.6",
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                    }}
                    dangerouslySetInnerHTML={{
                      __html:
                        // selectedReportData.background_brief ||
                        // reportHeader.background_brief ||
                        // "Enter your text here",

                        (selectedReportData.improvement_opportunity_areas ||
                          reportHeader.improvement_opportunity_areas ||
                          "Enter your text here"
                        )
                          .replace(/<br\s*\/?>/gi, "") // remove all <br> tags
                          .replace(/<p>\s*<\/p>/gi, "") // remove empty <p> tags (optional)

                    }}
                  >
                    {/* {selectedReportData.background_brief || reportHeader.background_brief || "Enter your text here"} */}
                    {/* {(selectedReportData.background_brief || reportHeader.background_brief || "Enter your text here")
      .replace(/<\/?[^>]+(>|$)/g, "")}  */}

                  </div>
                  <br />
                  </>
                )}
                
                {/* ANNEXURE-REFERENCES & STANDARDS */}
                {(screenNumber == 9 || completeReport) && (
                  <>
                  <div className="sub-headings">ANNEXURE-REFERENCES & STANDARDS</div>
                  <div className="table-containerr">
                    <table className="styled-tablee">
                      <thead>
                        <tr>
                          <th>Reference Type and Document / Standard</th>
                          <th>Relevance to Audit Findings</th>
                        </tr>
                      </thead>

                      <tbody>
                        {groupedReferences.map((group) => (
                          <React.Fragment key={group.key}>
                            {group.heading && (
                              <tr className="section-headingg">
                                <td colSpan="2">{group.heading.section_name}</td>
                              </tr>
                            )}
                            {group.rows.map((ref) => (
                              <tr key={ref.id}>
                                <td>{ref.document}</td>
                                <td>{ref.relevance}</td>
                              </tr>
                            ))}
                          </React.Fragment>
                        ))}

                      </tbody>
                    </table>
                  </div>
                  <br />
                  </>
                )}

                {/* CRITICAL OBSERVATIONS, RECOMMENDATIONS & REASONING - HSE REPORT */}
                {(screenNumber == 10 || completeReport) && (
                  <>
                  <div className="sub-headings">
                    CRITICAL OBSERVATIONS, RECOMMENDATIONS & REASONING - HSE REPORT
                  </div>

                  <div className="table-container">
                    {Object.keys(groupedObservations).length === 0 ? (
                      " No observations"

                    ) : (
                      Object.keys(groupedObservations).map((tableType) => {
                        const selectedObservations = groupedObservations[tableType].filter(
                          (e) => e.is_selected === 1
                        );

                        return (
                          <div key={tableType} className="grouped-table">
                            <h4>{tableType}</h4>
                            <TableContainer component={Paper}>
                              <Table>
                                <TableHead>
                                  <TableRow>
                                    <TableCell>Sr. No.</TableCell>
                                    <TableCell>Area / Process</TableCell>
                                    <TableCell>Equipment</TableCell>
                                    <TableCell>Category</TableCell>
                                    <TableCell>Check Point</TableCell>
                                    <TableCell>Criticality</TableCell>
                                    <TableCell>Status</TableCell>
                                    <TableCell>Observation</TableCell>
                                    <TableCell>Recommendation</TableCell>
                                    <TableCell>Legal Reference (if any)</TableCell>
                                    <TableCell>Max Points</TableCell>
                                    <TableCell>Score</TableCell>
                                    <TableCell>Objective Evidence</TableCell>
                                  </TableRow>
                                </TableHead>

                                <TableBody>
                                  {selectedObservations.length > 0 ? (
                                    selectedObservations.map((observation, index) => (
                                      <TableRow
                                        key={index}
                                        className={index % 2 === 0 ? "even-row" : "odd-row"}
                                      >
                                        <TableCell>{index + 1}</TableCell>
                                        <TableCell>{observation.area}</TableCell>
                                        <TableCell>{naValue(observation.equipment)}</TableCell>
                                        <TableCell>{naValue(observation.category)}</TableCell>
                                        <TableCell style={{
                                          whiteSpace: 'pre-wrap',
                                          wordWrap: 'break-word'
                                        }}
                                        >{naValue(observation.check_points)}</TableCell>
                                        <TableCell>{naValue(observation.criticality)}</TableCell>
                                        <TableCell>{naValue(observation.status)}</TableCell>
                                        <TableCell
                                          style={{
                                            whiteSpace: 'pre-wrap',
                                            wordWrap: 'break-word'
                                          }}
                                        >{naValue(observation.observation)}</TableCell>
                                        <TableCell style={{
                                          whiteSpace: 'pre-wrap',
                                          wordWrap: 'break-word'
                                        }}
                                        >{naValue(observation.recommendations)}</TableCell>
                                        <TableCell>{naValue(observation.legal_reference)}</TableCell>
                                        <TableCell>{naValue(observation.max_pts, 0)}</TableCell>
                                        <TableCell>{naValue(observation.score, 0)}</TableCell>
                                        <TableCell>
                                          <div className="image-container">
                                            {observation.imageUrls?.length > 0 ? (
                                              <>
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    padding: "6px 0",
                                                    border: "1px solid grey",
                                                    borderRadius: "5px",
                                                    width: "100px",
                                                    cursor: "pointer",
                                                  }}
                                                  onClick={() => handleOpenDialog(observation, index)}
                                                >
                                                  <InsertPhotoOutlinedIcon size={30} />
                                                </div>

                                                <Dialog
                                                  PaperProps={{
                                                    sx: {
                                                      border: "1px solid black",
                                                      borderRadius: "10px",
                                                    },
                                                  }}
                                                  onClose={handleCloseDialog}
                                                  open={openDialog}
                                                  maxWidth="md"
                                                  BackdropProps={{
                                                    style: { backgroundColor: "rgba(0, 0, 0, 0.1)" },
                                                  }}
                                                >
                                                  <DialogTitle>Uploaded Images</DialogTitle>
                                                  <DialogContent dividers>
                                                    <div
                                                      style={{
                                                        display: "grid",
                                                        gridTemplateColumns: "repeat(4, 1fr)",
                                                        gap: "10px",
                                                      }}
                                                    >
                                                      {selectedObservation?.imageUrls?.map(
                                                        (imageUrl, imgIndex) => (
                                                          <div
                                                            key={imgIndex}
                                                            style={{
                                                              display: "flex",
                                                              alignItems: "center",
                                                              flexDirection: "column",
                                                            }}
                                                          >
                                                            <img
                                                              src={imageUrl}
                                                              alt={`Image ${imgIndex + 1}`}
                                                              style={{
                                                                cursor: "pointer",
                                                                width: "200px",
                                                                height: "200px",
                                                                borderRadius: "5px",
                                                              }}
                                                              onClick={() => window.open(imageUrl, "_blank")}
                                                            />
                                                          </div>
                                                        )
                                                      )}
                                                    </div>
                                                  </DialogContent>
                                                  <DialogActions>
                                                    <Button onClick={handleCloseDialog}>Close</Button>
                                                  </DialogActions>
                                                </Dialog>
                                              </>
                                            ) : (
                                              <Typography variant="body2">N/A</Typography>
                                            )}
                                          </div>
                                        </TableCell>
                                      </TableRow>
                                    ))
                                  ) : (
                                    <TableRow>
                                      <TableCell
                                        colSpan={10}
                                        align="center"
                                        style={{ color: "gray", fontStyle: "italic" }}
                                      >
                                        No observations
                                      </TableCell>
                                    </TableRow>
                                  )}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </div>
                        );
                      })
                    )}
                  </div>
                  <br />
                  </>
                )}

                {/* OVERALL ASSESSMENT INDICATOR */}
                {(screenNumber == 11 || completeReport) && (
                  <>
                  <div className="sub-headings">OVERALL ASSESSMENT INDICATOR</div>
                  {/* Wrapper with flexbox: left (score box) + right (report view) */}
                  <div className="risk-wrapper" style={{ display: "flex", gap: "20px", alignItems: "stretch", marginBottom: "5px" }}>
                  {/* Left Risk Box */}
                  <div
                      className="left-section"
                      style={{
                        width: "200px",
                        padding: "10px",
                        borderRadius: "4px",
                        backgroundColor: currentRisk.color,
                        color: "#000",
                        flexShrink: 0,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        fontFamily: "Montserrat",
                        fontSize: "20px",
                        fontWeight: "bold",
                      }}
                    >
                  {/* <p style={{ margin: 0 }}>{Math.floor((selectedReportData.cumulative / 10) * 100)}%</p> */}
                  <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                    <p style={{ margin: 0, fontSize: "24px", fontWeight: "bold" }}>{scorePercent}%</p>
                    <p style={{ margin: "4px 0 0 0", fontSize: "12px", fontWeight: "bold" }}>{currentRisk.risk}</p>
                  </div>
                  </div>

                  {/* Right Report Content */}
                  <div
                      style={{
                        flexGrow: 1,
                        minHeight: "100px",
                        maxHeight: "400px",
                        overflowY: "auto",
                        padding: "8px",
                        border: "1px solid #ccc",
                        borderRadius: "5px",
                        fontFamily: "inherit",
                        fontSize: "15px",
                        background: "whitesmoke",
                        lineHeight: "1.6",
                        wordWrap: "break-word",
                        whiteSpace: "normal",
                      }}
                      dangerouslySetInnerHTML={{
                        __html:
                          (selectedReportData.overall_assessment_indicator ||
                            reportHeader.overall_assessment_indicator ||
                            "Enter your text here")
                            .replace(/<br\s*\/?>/gi, "")
                            .replace(/<p>\s*<\/p>/gi, ""),
                      }}
                    />
                  </div>
                  {/* Risk Legend Table */}
                  <div style={{ marginBottom: "20px", overflowX: "auto" }}>
                    <h3 style={{ color: "#307260", fontFamily: "Montserrat" }}>Risk Legend</h3>
                  {/* <p style={{fontFamily: "Montserrat"}}>The above image is per display purpose only</p> */}
                  <table style={{ width: "100%", borderCollapse: "collapse", fontFamily: "Montserrat" }}>
                      <thead>
                        <tr style={{ backgroundColor: "#307260", color: "#efc71d" }}>
                          <th style={{ padding: "8px", border: "1px solid #000", fontSize: "14px" }}>Score Range</th>
                          <th style={{ padding: "8px", border: "1px solid #000", fontSize: "14px" }}>Risk Level</th>
                          <th style={{ padding: "8px", border: "1px solid #000", fontSize: "14px" }}>Interpretation</th>
                        </tr>
                      </thead>
                      <tbody>
                        {riskLevels.map((level, index) => (
                          <tr key={index}>
                            <td
                              style={{
                                textAlign: "center",
                                color: level.color,
                                border: "1px solid #000",
                                padding: "8px",
                                fontSize: "13px",
                              }}
                            >
                              {level.range}
                            </td>
                            <td
                              style={{
                                textAlign: "center",
                                backgroundColor: level.color,
                                color: "#000",
                                border: "1px solid #000",
                                padding: "8px",
                                fontSize: "13px",
                              }}
                            >
                              {level.risk}
                            </td>
                            <td style={{ border: "1px solid #000", padding: "8px", fontSize: "13px" }}>
                              {level.interpretation}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <br />
                  </>
                )}

                {/* DASHBOARD */}
                {(screenNumber == 12 || completeReport) && (
                  <>
                  <div className="sub-headings">DASHBOARD</div>
                  <div
                    id="chart-container-for-report"
                    className="chart-container-for-report"
                  >
                    <div className="total-serverity-div-for-report">
                      <div className="severity-item-for-report">
                        Total Observations
                        <br />
                        {/* <span>{data.length}</span> */}
                        <span>{data.filter((e) => !(e.criticality === "" || e.criticality === "N/A")).length}</span>
                        <hr />
                      </div>
                      <div
                        style={{ color: "#FF0000" }}
                        className="severity-item-for-report"
                      >
                        High Severity Observations
                        <br />
                        <span>
                          {data.filter((e) => e.criticality === "High").length}
                        </span>
                        <hr />
                      </div>
                      <div
                        style={{ color: "#006400" }}
                        className="severity-item-for-report"
                      >
                        Medium Severity Observations
                        <br />
                        <span>
                          {data.filter((e) => e.criticality === "Medium").length}
                        </span>
                        <hr />
                      </div>
                      <div
                        style={{ color: "#005cdb" }}
                        className="severity-item-for-report"
                      >
                        Low Severity Observations
                        <br />
                        <span>
                          {data.filter((e) => e.criticality === "Low").length}
                        </span>
                        <hr />
                      </div>
                    </div>
                    <div className="area-chart-for-report">
                      Area Chart
                      <Chart
                        options={barOptions}
                        series={[
                          {
                            name: "",
                            data: counts,
                          },
                        ]}
                        type="bar"
                        height={300}
                      />
                    </div>
                    <div className="severity-chart-for-report">
                      Severity Chart
                      <Chart
                        options={severityChartOptions}
                        series={seriesData}
                        type="bar"
                        height={300}
                      />
                    </div>
                    <div
                      className="pie-chart-for-report"
                      role="img"
                      aria-label={`Audit Score pie chart. Score ${scorePercent}%, Remaining ${100 - scorePercent}%.`}
                    >
                      Audit Score

                      {(() => {
                        // SAFE SCORE
                        const safeScore = Number(scorePercent);

                        // VALIDATE
                        const validScore =
                          isFinite(safeScore) &&
                            !isNaN(safeScore)
                            ? Math.min(100, Math.max(0, safeScore))
                            : 0;

                        const remaining = 100 - validScore;

                        // When the "Remaining" sliver is tiny (<= 5%), its in-slice
                        // label is suppressed by the dataLabels formatter to avoid
                        // overlapping the "Score" label. Show the value just above
                        // the circle instead.
                        const showRemainingOutside = remaining > 0 && remaining <= 5;

                        return (
                          <div
                            style={{
                              position: "relative",
                              paddingTop: showRemainingOutside ? "18px" : 0,
                            }}
                          >
                            {showRemainingOutside && (
                              <span
                                style={{
                                  position: "absolute",
                                  top: 10,
                                  left: "50%",
                                  transform: "translateX(-50%)",
                                  fontSize: "12px",
                                  fontWeight: "bold",
                                  color: "#000000",
                                  // Black text on the light page background keeps the
                                  // value legible; the subtle shadow still mirrors the
                                  // in-slice label drop shadow.
                                  textShadow: "0 1px 2px rgba(0, 0, 0, 0.85)",
                                  whiteSpace: "nowrap",
                                  zIndex: 2,
                                  pointerEvents: "none",
                                }}
                              >
                                {remaining.toFixed(0)}%
                              </span>
                            )}
                            <Chart
                              options={pieOptions}
                              series={[validScore, remaining]}
                              type="pie"
                              width="100%"
                              height={250}
                            />
                          </div>
                        );
                      })()}
                    </div>
                  </div>
                  <br />
                  </>
                )}

                {/* CONCLUSION */}
                {(screenNumber == 13 || completeReport) && (
                  <>
                  <div className="sub-headings">CONCLUSION</div>
                  <div
                    className="conclusion-content"
                    style={{
                      background: "whitesmoke",
                      // width: "98.8%",
                      minHeight: "100px", // Ensures a reasonable default height
                      maxHeight: "200px", // Prevents excessive expansion
                      overflowY: "auto", // Enables scrolling when content overflows
                      padding: "8px", // Adds spacing inside the div
                      border: "1px solid #ccc", // Light border for better readability
                      borderRadius: "4px", // Rounded corners for a clean look
                      fontFamily: "inherit", // Ensures consistency with other text areas
                      fontSize: "15px", // Maintains readability
                      // whiteSpace: "pre-wrap", // Preserves line breaks and spacing
                      lineHeight: "1.6",
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                    }}
                    dangerouslySetInnerHTML={{
                      __html:
                        (selectedReportData.conclusion ||
                          reportHeader.conclusion ||
                          '<em style="color: #999;">Enter your text here</em>').replace(/<br\s*\/?>/gi, "") // remove all <br> tags
                          .replace(/<p>\s*<\/p>/gi, "")
                    }}
                  >

                  </div>
                  </>
                )}
              </Typography>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default ViewHseReportSectionBasedDetails;
